import { NgModule } from '@angular/core';
import { MppTabGroupModule } from './tab-group';

@NgModule({
  imports: [MppTabGroupModule],
  exports: [MppTabGroupModule],
})
export class MppTabsModule {}
